export default "__VITE_ASSET__VxIpHLY5__"